export default __webpack_public_path__ + "static/media/movipack_feature5.94ce82b9.svg";